import { render, staticRenderFns } from "./AltbestaendeTabelle.vue?vue&type=template&id=57a29b13&"
import script from "./AltbestaendeTabelle.vue?vue&type=script&lang=js&"
export * from "./AltbestaendeTabelle.vue?vue&type=script&lang=js&"
import style0 from "./AltbestaendeTabelle.vue?vue&type=style&index=0&id=57a29b13&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports